/* eslint-disable import/prefer-default-export */
import { _firestore, db } from '@/lib/db';
import store from '@/store';

export const RecentlyViewed = () => _firestore
	.collection( `users/${store.state.user.uid}/recentlyViewed` )
	.get();

export const AddRecentlyViewed = async ( assetName, recentlyViewed, assetKey ) => {
	const recentlyViewedRef = _firestore
		.collection( `users/${store.state.user.uid}/recentlyViewed` );

	// first we need to see if this was already in the users recently viewed, if so we need to just update the viewedAt property
	const duplicates = await recentlyViewedRef
		.doc( `${assetName}_${assetKey}` )
		.get();

	// if there was any duplicates we'll just update instead of add a new one
	if ( duplicates && duplicates.size > 0 ) {

		const duplicateId = duplicates.docs[0].id;

		return recentlyViewedRef
			.doc( duplicateId )
			.update( {
				type     : assetName,
				asset    : recentlyViewed,
				viewedAt : new Date(),
				assetKey,
			} );

	}

	const recents = await recentlyViewedRef
		.orderBy( 'viewedAt' )
		.get();

	// if there's more documents than what we are allowing we'll go ahead and delete the oldest one and in the next code block add our new document
	if ( recents.size > 10 ) {
		// grab the documents id that we're going to be deleting
		const firstDocId = recents.docs[0].id;

		// * NOTE: We need the id because firestore doesn't allow for you to just delete based on it's position but only by it's refernce * //

		// since we have the id, now we're going to delete it.
		recentlyViewedRef.doc( firstDocId ).delete();
	}

	return recentlyViewedRef
		.doc( `${assetName}_${assetKey}` )
		.set( {
			type     : assetName,
			asset    : recentlyViewed,
			viewedAt : new Date(),
			assetKey,
		} );

};

export const GetLastUpdated = ( assetName, cb ) => db
	.child( 'lastUpdated' )
	.child( assetName )
	.on( 'value', ( snapshot ) => {
		const data = snapshot.val();

		if ( !data ) {
			// console.log( 'No Data Available.' );
			return;
		}

		cb( {
			key   : data.affectedKey,
			asset : assetName,
		} );
	} );

export const GetLastDeleted = ( assetName, cb ) => db
	.child( 'lastDeleted' )
	.child( assetName )
	.on( 'value', ( snapshot ) => {

		const data = snapshot.val();

		if ( !data ) {
			// console.log( 'No Data Available.' );
			return;
		}

		cb( {
			key   : data.affectedKey,
			asset : assetName,
		} );

	} );
